// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE, // "development" ou "production"
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // Actif dès que le DSN est présent (dev inclus pour les tests)
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
})


// Note : React.StrictMode retiré intentionnellement.
// En développement il monte les composants deux fois, ce qui provoque
// l'avertissement "Lock not released" de Supabase Auth et l'écran bleu.
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
